import apiClient from './client';

export interface InsightsQuery {
  query: string;
}

export interface InsightsResponse {
  answer?: string;
  message?: string;
  data?: any;
  debug?: any;
}

export interface CloseSummary {
  topCloses: Array<{
    lead_id: number;
    lead_name: string;
    brand: string | null;
    probability: number;
    value: number;
    currency?: 'USD' | 'INR';
    stage: string;
    reason: string;
  }>;
  atRisk: Array<{
    lead_id: number;
    lead_name: string;
    brand: string | null;
    risk_reason: string;
    days_in_stage: number;
  }>;
  summary: string;
}

export const insightsApi = {
  query: async (query: string): Promise<InsightsResponse> => {
    const response = await apiClient.post<{ success: boolean; data: InsightsResponse }>('/insights/query', { query });
    return response.data.data;
  },
  getCloseSummary: async (period: 'weekly' | 'monthly' | 'quarterly' = 'monthly'): Promise<CloseSummary> => {
    const response = await apiClient.get<{ success: boolean; data: CloseSummary }>(`/insights/close-summary?period=${period}`);
    return response.data.data;
  },
};
